(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('.collection-sort select').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const lightbox = section.querySelector('[data-product-lightbox]');
    const zoomTriggers = Array.from(section.querySelectorAll('[data-product-zoom-trigger]'));

    if (lightbox && zoomTriggers.length) {
      const lightboxImage = lightbox.querySelector('[data-lightbox-image]');
      const lightboxStatus = lightbox.querySelector('[data-lightbox-status]');
      const previousButton = lightbox.querySelector('[data-lightbox-previous]');
      const nextButton = lightbox.querySelector('[data-lightbox-next]');
      const closeButtons = lightbox.querySelectorAll('[data-lightbox-close]');
      let currentIndex = 0;
      let returnFocus = null;

      const updateLightbox = (index) => {
        currentIndex = (index + zoomTriggers.length) % zoomTriggers.length;
        const trigger = zoomTriggers[currentIndex];
        lightboxImage.src = trigger.dataset.imageUrl;
        lightboxImage.alt = trigger.dataset.imageAlt || '';
        lightboxStatus.textContent = `Image ${currentIndex + 1} of ${zoomTriggers.length}`;
      };

      const closeLightbox = () => {
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        lightboxImage.src = '';
        document.body.style.overflow = '';
        if (returnFocus) returnFocus.focus();
      };

      const openLightbox = (index, trigger) => {
        returnFocus = trigger;
        updateLightbox(index);
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        lightbox.querySelector('.product-lightbox__close').focus();
      };

      zoomTriggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => openLightbox(index, trigger));
      });
      closeButtons.forEach((button) => button.addEventListener('click', closeLightbox));
      previousButton.addEventListener('click', () => updateLightbox(currentIndex - 1));
      nextButton.addEventListener('click', () => updateLightbox(currentIndex + 1));

      if (zoomTriggers.length < 2) {
        previousButton.hidden = true;
        nextButton.hidden = true;
      }

      lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft' && zoomTriggers.length > 1) updateLightbox(currentIndex - 1);
        if (event.key === 'ArrowRight' && zoomTriggers.length > 1) updateLightbox(currentIndex + 1);
      });
    }

    const select = section.querySelector('[data-variant-select]');
    if (!select) return;
    const variants = JSON.parse(section.querySelector('[data-variant-json]').textContent);
    const price = section.querySelector('[data-product-price]');
    const button = section.querySelector('[data-add-button]');
    const label = section.querySelector('[data-add-label]');
    const currency = section.dataset.currency || 'USD';
    const soldOutText = select.options[select.selectedIndex]?.text.includes('—') ? select.options[select.selectedIndex].text.split('—')[1].trim() : 'Sold out';
    const addText = label.textContent.trim();
    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(variant.price / 100);
      button.disabled = !variant.available;
      label.textContent = variant.available ? addText : soldOutText;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  (() => {
    const nav = document.querySelector('.desktop-nav');
    if (!nav) return;

    const groups = Array.from(nav.querySelectorAll('.desktop-nav__group'));

    const closeOthers = (activeGroup) => {
      groups.forEach((group) => {
        if (group !== activeGroup) group.removeAttribute('open');
      });
    };

    groups.forEach((group) => {
      group.addEventListener('toggle', () => {
        if (group.open) closeOthers(group);
      });
    });

    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target)) {
        groups.forEach((group) => group.removeAttribute('open'));
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        groups.forEach((group) => group.removeAttribute('open'));
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 1020) {
        groups.forEach((group) => group.removeAttribute('open'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
